import React from "react";
import css from './footerPromiseFloor.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";

const items = [
    {
        img: require('./img/footer正icon.png'),
        title: '正品承诺',
        subTitle: '正品保障 假一赔十'
    },
    {
        img: require('./img/footer退icon.png'),
        title: '7天无忧退货',
        subTitle: '不满包退 售后无忧'
    },
    {
        img: require('./img/footer快icon.png'),
        title: '闪电发货',
        subTitle: '多仓直发 急速配送'
    },
    {
        img: require('./img/footer好icon.png'),
        title: '权威荣誉',
        subTitle: '好评如潮 值得信赖'
    },
    {
        img: require('./img/footer低icon.png'),
        title: '低价保障',
        subTitle: '确保低价 畅选无忧'
    },
]

const Index = ({className}) => {
    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={css.promiseItemList}>
                    {
                        items.map((item, i) => {
                            const {img, title, subTitle} = item
                            return (
                                <div key={i} className={css.promiseItem}>
                                    <div className={css.iconWrapper}>
                                        <img src={img} alt=""/>
                                    </div>
                                    <div className={css.right}>
                                        <div className={css.title}>
                                            {title}
                                        </div>
                                        <div className={css.subtitle}>
                                            {subTitle}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default observer(Index)